import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { queryClient } from '@/shared/lib/query-client';

type QueryProviderProps = {
  children: ReactNode;
};

/**
 * TanStack Query Provider
 *
 * App層の責務:
 * - QueryClientProvider でアプリケーション全体をラップ
 * - shared/lib の queryClient インスタンスを使用
 */
export const QueryProvider = ({ children }: QueryProviderProps) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
